module.exports = __webpack_public_path__ + "img/DJI_0564.c0336906.gif";